'use client';

import type { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import type { TRPCClient } from '@trpc/client';
import type { ReactNode } from 'react';
import { useState } from 'react';
import type { AppRouter } from '@/types/app-router';
import { createTrpcClient, createTrpcQueryClient, trpc } from './client';

interface TrpcProviderProperties {
  children: ReactNode;
  client?: TRPCClient<AppRouter>;
  includeQueryClientProvider?: boolean;
  queryClient?: QueryClient;
}

export function TrpcProvider({
  children,
  client,
  queryClient,
  includeQueryClientProvider = true,
}: TrpcProviderProperties) {
  const [fallbackQueryClient] = useState(() => createTrpcQueryClient());
  const [fallbackTrpcClient] = useState(() => createTrpcClient());

  const resolvedQueryClient = queryClient ?? fallbackQueryClient;
  const resolvedTrpcClient = client ?? fallbackTrpcClient;

  const content = includeQueryClientProvider ? (
    <QueryClientProvider client={resolvedQueryClient}>{children}</QueryClientProvider>
  ) : (
    children
  );

  return (
    <trpc.Provider client={resolvedTrpcClient} queryClient={resolvedQueryClient}>
      {content}
    </trpc.Provider>
  );
}
